/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_TitleInputs */

const da_print_title = /** @type {(inputs: Print_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udskriv rettelser`)
};

/** @type {(inputs: Print_TitleInputs) => LocalizedString} */
const en_print_title = da_print_title;

/**

* @param {Print_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const print_title = /** @type {((inputs?: Print_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_print_title(inputs)
	return /** @type {LocalizedString} */ ("Udskriv rettelser")
});